import React from 'react'

import { ButtonAndFormModal } from '@/components/layout/modals/ButtonAndFormModal'
import { WebhookSubscriptionForm } from '@/views/Organizations/components/WebhookSubscriptionForm'

export const ManageWebhookSubscriptionButton = ({ organizationId }) => {
  return (
    <ButtonAndFormModal
      buttonLabel="Manage Post-Call Webhook"
      modalTitle="Manage Post-Call Webhook"
      modalId="manage-webhook-subscription"
      modalProps={{ size: 'small' }}
      buttonProps={{ primary: true }}
      form={<WebhookSubscriptionForm organizationId={organizationId} />}
    />
  )
}
